import { NgModule } from '@angular/core';
import { SidebarComponent } from './sidebar.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HomeSelectorComponent } from './home-selector/home-selector.component';
import { HoverTextComponent } from './hover-text/hover-text.component';
import { LegalsButtonsComponent } from './legals-buttons/legals-buttons.component';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { SharedModule } from 'src/app/components/shared.module';
import { SidebarLinkComponent } from './sidebar-link/sidebar-link.component';
@NgModule({
  declarations: [
    SidebarComponent,
    HomeSelectorComponent,
    HoverTextComponent,
    LegalsButtonsComponent,
    SidebarLinkComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    PipesModule,
  ],
  exports: [
    SidebarComponent
  ],
})
export class SidebarModule { }
